import {useState} from "react";
import './styles.css';
import { Grid, Divider, Typography, IconButton, FormControl, InputLabel, Select, OutlinedInput, MenuItem } from "@mui/material";
import { useIsSmallScreen, useIsTinyMobileScreen, useIsMobileScreen} from "../../hooks/screenSizeHooks";
import { MIDI_VIOLIN_SOUND_CHOICE } from '../../utils';
import { midiPlaySound } from '../../hooks/midiPlaySound';
import InvisibleMidiSound from "../InvisibleMidiSound";
import ViolinTunerPitchDetector from "../ViolinTunerPitchDetector";
import useMediaQuery from '@mui/material/useMediaQuery';

const openStringsSound = [
  {stringName: 'G', octave: 4, number: 7, stringLabel: 'G string', pitchHz: 196 },
  {stringName: 'D', octave: 4, number: 14, stringLabel: 'D string', pitchHz: 293.66},
  {stringName: 'A', octave: 5, number: 9, stringLabel: 'A string', pitchHz: 440},
  {stringName: 'E', octave: 5, number: 16, stringLabel: 'E string', pitchHz: 659.26 },
];

const MIDI_LENGTH = 1;

const ViolinTuner = () =>  {
  const isSmallScreen = useIsSmallScreen();
  const isTinyMobileScreen = useIsTinyMobileScreen();
  const isMobileScreen = useIsMobileScreen();
  const [selectedString, setSelectedString] = useState();
  const showSidedBySideFormat = useMediaQuery('(min-width:760px)');

  const onStringSelectionChange = (e) => {
    const x = openStringsSound.find(string => string.stringLabel === e.target.value)
    setSelectedString(x) 
  };

  const onOpenStringButtonClick = (octave, number) => {
    midiPlaySound(octave, number, MIDI_VIOLIN_SOUND_CHOICE, MIDI_LENGTH)
  }

  return (
    <>
      <InvisibleMidiSound soundChoices={[MIDI_VIOLIN_SOUND_CHOICE]}/>
      <Grid container direction='row'  justifyContent='space-evenly' alignItems={showSidedBySideFormat ? 'center': 'flex-start'}>
        {/**This is the Listen Side */}
        <Grid item size={{ xs: 12, md: 6 }} justifyItems={'center'}> 
            <Typography variant={isMobileScreen ? "h6" : "h5"} className="tunerOptionHeader"  >Option 1: Listen to Match</Typography>
            <Typography variant="subtitle1" className="tunerTextColor">Click on a button to listen to its pitch</Typography>
            <Grid container direction='row' justifyContent={'center'} >
              {openStringsSound.map(string => (
                <Grid item key={string.stringName} style={{marginBottom: '30px', marginTop: showSidedBySideFormat ? '30px' : '10px'}}>
                  <IconButton
                      size={isTinyMobileScreen ? 'small' : isSmallScreen ? 'medium' : 'large'}
                      style={{boxShadow: '0 10px 20px 0 #666666', backgroundColor: ' #9c27b0', color: ' #ffffff', width: isTinyMobileScreen ? '35px' : '57px', margin: '3px'}}
                      onClick={() => onOpenStringButtonClick(string.octave, string.number)}   
                      >
                   <Typography>{string.stringName}</Typography> 
                  </IconButton>
                 </Grid> 
              ))}
            </Grid>
        </Grid>

        {showSidedBySideFormat && <Divider orientation="vertical" variant="fullWidth" flexItem className="dividerStyle" ><Typography className="tunerTextColor">Or</Typography></Divider> }

        {/**This is the Play Side */}
        <Grid item size={{ xs: 12, md: 6 }} justifyItems={'center'}>
          <Typography variant={isMobileScreen ? "h6" : "h5"} className="tunerOptionHeader" >Option 2: Play to the Violin Tuner</Typography>
          <Typography variant="subtitle1" className="tunerTextColor" style={{textAlign: 'center'}}>Select a string you wish to tune and then play</Typography>
          <Typography variant="subtitle1"className="tunerTextColor" style={{textAlign: 'center'}}>(Ensure your browser mic is on)</Typography>
          <Grid container direction={'column'} alignItems={'center'} >
            <Grid item>
              <FormControl size="small" htmlFor='select-string-input' style={{minWidth: '250px', marginTop: '15px', marginBottom: '15px'}}>
                <InputLabel color='secondary'>Select a string</InputLabel>
                  <Select
                    name='string-select'
                    value={!!selectedString ? selectedString.stringLabel : ''}
                    onChange={onStringSelectionChange}
                    className="selectStringInput"
                    color='secondary'
                    input={<OutlinedInput label="Select a string" id='select-string-input'  color='secondary' />}
                  >
                    {!!openStringsSound && openStringsSound.map(string => (
                      <MenuItem key={string.stringLabel} value={string.stringLabel} disabled={!!selectedString && selectedString.stringLabel === string.stringLabel}>{string.stringLabel}</MenuItem>
                    ))}
                  </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {!!selectedString && <ViolinTunerPitchDetector selectedString={selectedString} />}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default ViolinTuner;